(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('sedute-pubbliche', {
            parent: 'app', 
            url: '/sedute-pubbliche?page&sort&legislatura&anno&tipoOrganismo&idOrganismo',
            data: {
                authorities: [],
                pageTitle: 'gestioneAttiApp.sedute-pubbliche.title' 
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sedute-pubbliche/sedute-pubbliche.html',
                    controller: 'SedutePubblicheController',
                    controllerAs: 'vm'
                },
                'navbar@' : {
                    templateUrl: 'app/layouts/navbar/navbar-commission-pages.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'numeroSeduta,desc',
                    squash: false
                },
                anno : {
                    value: null,
                    squash: false
                },
                tipoOrganismo : {
                    value: null,
                    squash: false
                },
                idOrganismo : {
                    value: null,
                    squash: false
                },
                legislatura : {
                    value: null,
                    squash: false
                },
            },
            resolve: {
                legislaturaDetails: ['Atto', '$stateParams', function(Atto, $stateParams) {
                    return Atto.legislatura({default: $stateParams.legislatura}).$promise;
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('seduta');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
